.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--color-surface-primary);
  border: 1px solid var(--color-grey-soft);
  border-radius: map.get($radius, 'md');
  box-shadow: 0 4px 20px 0 var(--color-grey-light);
}

.filterWrapper {
  padding: map.get($spacing-scale, 's-2'); // 8px
  padding-bottom: 0;
}

.listWrapper {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 's-1'); // 4px per Figma
  padding: map.get($spacing-scale, 's-2'); // 8px per Figma
  overflow-y: auto;
}

.noResults {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: map.get($spacing-scale, 'md') map.get($spacing-scale, 'sm');
  color: var(--color-text-tertiary);
  @include body-small-regular;
}

// Group wrapper — preserves the existing list-item gap inside the group.
.group {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 's-1'); // 4px, matches .listWrapper

  // Separator between groups (skip on first group).
  & + & {
    margin-top: map.get($spacing-scale, 's-2'); // 8px
    padding-top: map.get($spacing-scale, 's-2');
    border-top: 1px solid var(--color-grey-soft);
  }
}

// Group header label — small uppercase caption above each section.
.groupHeader {
  @include metadata-small-medium;

  padding: map.get($spacing-scale, 's-1') map.get($spacing-scale, 's-2');
  color: var(--color-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  user-select: none;
}
